import { checkout } from '~/store/checkout'
import { shop } from '~/store/shop'
import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
import { isCheckoutPath, isDeliveryPath, isPickupPath } from '~/utils/path-utils'

export default defineNuxtRouteMiddleware(async to => {
    if (isDeliveryPath(to.fullPath) || (isCheckoutPath(to.fullPath) && checkout().input.dispatchType === DispatchTypeOrderBuddy.DELIVER)) {
        await shop().getDeliveryMenu()
    }
    if (isPickupPath(to.fullPath) || (isCheckoutPath(to.fullPath) && checkout().input.dispatchType === DispatchTypeOrderBuddy.PICK_UP)) {
        await shop().getPickupMenu()
    }
    return true
})
